import Icon from "./Icon";
import "./events.css";

/**
 * Shown when the event can't be resolved at all. There's no event payload here,
 * so no shop details are available — the fallback has to stay generic.
 */
const ErrorState = () => (
  <div className="ev-wrap ev-wrap--narrow ev-confirm-center">
    <div className="ev-alert-badge">
      <Icon name="warn" size={34} color="var(--brand-persimmon)" />
    </div>
    <h1 className="ev-h1">We couldn't find that event</h1>
    <p className="ev-lead ev-lead--center">
      This link may be incorrect or expired. If you were invited to an event,
      please check the link in your invitation.
    </p>
    <p className="ev-lead ev-lead--center ev-contact-generic">
      To reach your local Christian Brothers Automotive, visit{" "}
      <a
        href="https://www.cbac.com/locations/"
        target="_blank"
        rel="noopener noreferrer"
      >
        cbac.com/locations
      </a>
      .
    </p>
  </div>
);

export default ErrorState;
